function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.143 0h-.285L.5 4.445v8.02L8.828 18h.344l8.328-5.536v-8.02L9.142 0zm6.591 4.781l-2.71 1.441-3.01-1.6 2.709-1.442 3.011 1.601zm-6.733-3.58l2.71 1.44L9 4.082l-2.71-1.44L9.001 1.2zM5.278 3.18l2.71 1.44-3.011 1.601-2.71-1.441 3.011-1.6zM3.991 13.428l-2.357-1.567V9.136l2.357 1.462v2.831zm0-3.95L1.634 8.016V5.72l2.357 1.253v2.506zm4.443 6.903l-3.487-2.317v-2.873l3.487 2.163v3.028zm0-4.146l-3.487-2.163v-2.59l3.487 1.854v2.899zm.567-3.874L5.99 6.76 9 5.16l3.011 1.6-3.01 1.6zm4.054 5.703l-3.487 2.317v-3.028l3.487-2.163v2.874zm0-3.992l-3.487 2.163v-2.9l3.487-1.853v2.59zm3.313 1.79l-2.356 1.566v-2.831l2.356-1.462v2.729zm0-3.846L14.012 9.48V6.975l2.356-1.254v2.297z"
});

function SvgCube(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.b4b8ab500b0ecfdc739c81e76b3b26a1.svg";
export { ForwardRef as ReactComponent };